module.exports = __webpack_public_path__ + "media/fonts/CircularStd-Book-c1441dbff704baa78817a36353ae5859.otf";